import * as user from "./user.js"

 export default {
 	user
 }



// WEBPACK FOOTER //
// ./src/api/index.js